export default () => ({
  toastMessageQueue: [],
  headerMessage: '',
});
